export default `
    <link href='/images/snippetsMedia/welcome/index.css' rel='stylesheet' />
    <div class="wl-section--wrap wl-section--wrap__green">
      <div class="wl-section">
        <div class="wl-section--txt">
          <div class="wl-section--title">CAZINO</div>
          <div class="wl-section--subTxt">Ia-ti acum pachetul de bun venit</div>
          <div class="wl-section--mainTxt">FAVBONUS XXXX RON<br/>+ pana la xxx ROTIRI GRATUITE</div>
          <div class="wl-section--secondaryTxt">Tu ne-ai ales pe noi, iar noi te rasplatim pe masura! Foloseste codul de bun venit si intra acum in posesia #FAVbonusului.</div>
          <a href="../register" class="wl-section--submitBtn">
            <span class="wl-section--animatedTxt">Accepta</span>
          </a>
          <a href="#" class="wl-section--detailsBtn">Afla mai multe</a>
        </div>
      </div>
    </div>
  `;
